import React, { useEffect, useState } from 'react'
import abimg from '../../images/photo2.jpg'
import photo2Avif480 from '../../images/photo2-480.avif'
import photo2Avif768 from '../../images/photo2-768.avif'
import photo2Avif1024 from '../../images/photo2-1024.avif'
import photo2Avif1440 from '../../images/photo2-1440.avif'
import photo2Webp480 from '../../images/photo2-480.webp'
import photo2Webp768 from '../../images/photo2-768.webp'
import photo2Webp1024 from '../../images/photo2-1024.webp'
import photo2Webp1440 from '../../images/photo2-1440.webp'
import { useNavigate } from 'react-router-dom'
import OptimizedImage from '../OptimizedImage'
import { ConfigurableContainer } from '../ConfigurableElement'
import { useUIConfig } from '../../hooks/useUIConfig'
import { useAuth } from '../../hooks/useAuth'
import { useSubscription } from '../../hooks/useSubscription'
import { toast } from 'react-toastify'
import AuthModal from '../AuthModal'
import arabicBg from '../../images/arabic-bg-dark.svg'
import girlImg from '../../images/children/girl.png'
import { useTranslation } from 'react-i18next'
import './about-custom.css'


const About = (props) => {
    const { t } = useTranslation();
    const { applyCSS } = useUIConfig();
    const { isAuthenticated } = useAuth();
    const { hasActiveSubscription, isDemoSubscription } = useSubscription();
    const navigate = useNavigate();
    const [showAuthModal, setShowAuthModal] = useState(false);

    // Apply CSS when component mounts
    useEffect(() => {
        applyCSS();
    }, [applyCSS]);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const handleDemoClick = (e) => {
        e.preventDefault();
        ClickHandler();

        console.log('About - handleDemoClick - isAuthenticated:', isAuthenticated);
        console.log('About - handleDemoClick - hasActiveSubscription:', hasActiveSubscription);
        console.log('About - handleDemoClick - isDemoSubscription:', isDemoSubscription);

        if (!isAuthenticated) {
            console.log('About - Opening AuthModal for demo');
            setShowAuthModal(true);
        } else if (hasActiveSubscription && !isDemoSubscription) {
            toast.info(t('about.alreadySubscribed'));
            navigate('/dashboard');
        } else if (isDemoSubscription) {
            toast.info(t('about.alreadyDemo'));
            navigate('/dashboard');
        } else {
            navigate('/demo-confirmation');
        }
    }

    return (
        <section
            id="about"
            className={`wpo-about-section ${props.abClass}`}
            style={{
                position: 'relative'
            }}
        >
            {/* Arabic Background */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${arabicBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.05,
                    zIndex: 0
                }}
            />
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="about-img">
                            <OptimizedImage
                                src={abimg}
                                alt={t('about.altText')}
                                loading="lazy"
                                decoding="async"
                                avifSrcSet={`${photo2Avif480} 480w, ${photo2Avif768} 768w, ${photo2Avif1024} 1024w, ${photo2Avif1440} 1440w`}
                                webpSrcSet={`${photo2Webp480} 480w, ${photo2Webp768} 768w, ${photo2Webp1024} 1024w, ${photo2Webp1440} 1440w`}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 600px"
                                width={1200}
                                height={800}
                            />
                            <div className="shape-1"></div>
                            <div className="shape-2"></div>
                            <span className="ab-btn">{t('about.highlyQualifiedTeachers')}</span>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-content text-left">
                            <div className="section-title text-left">
                                <span>{t('about.title')}</span>
                                <h2>{t('about.heading')}
                                </h2>
                                <div className="transparent-text">About</div>
                            </div>
                            <p>{t('about.description1')}</p>
                            <p>{t('about.description2')}</p>
                            <a href="#" onClick={handleDemoClick} className="theme-btn-s2">{t('about.requestDemo')}</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Girl image positioned at bottom right of about section */}
            <ConfigurableContainer
                section="about"
                element="girlImage"
                className="girl-image-container"
            >
                <img src={girlImg} alt={t('about.girlImageAlt')} className="girl-image" loading="lazy" decoding="async" />
            </ConfigurableContainer>

            {/* Authentication Modal */}
            <AuthModal
                isOpen={showAuthModal}
                onClose={() => setShowAuthModal(false)}
                title={t('about.authModalTitle')}
                message={t('about.authModalMessage')}
                type="demo"
                redirectState={{ action: 'demo' }}
            />
        </section>
    )
}

export default About;